export default __webpack_public_path__ + "static/media/user-program-page.6f0ec080.png";